import { IGraphsState } from '../../../types/redux';

export function getLabels(graphsData: IGraphsState): string[] {
  const { data } = graphsData;

  return data ? data.labels : [];
}
